// extracted by mini-css-extract-plugin
module.exports = {"tableWrapper":"Table_tableWrapper__3a_SH","col":"Table_col__3yo6H","fulfillmentStatus":"Table_fulfillmentStatus__3mFxu","emailCol":"Table_emailCol__2gSIL"};